import { Component, inject, Input, OnChanges } from '@angular/core';
import { MultiOrderImportResult } from '../../../services/order-import.service';
import { Order } from '../../../models/order';
import { OrderSubmitService } from '../../../services/order-submit.service';
import { first } from 'rxjs';
import { GungFlowService } from '../../../services/gung-flow/gung-flow.service';
import { CustomerSpecificProductInformation } from '../../../models/product';
import { ProductService } from '../../../services/products/product.service';


@Component({
  selector: 'lib-multi-order-excel-import-result',
  templateUrl: './multi-order-excel-import-result.component.html',
  styleUrls: ['./multi-order-excel-import-result.component.scss'],
  standalone: false
})
export class MultiOrderExcelImportResultComponent implements OnChanges {

  protected productService = inject(ProductService);
  protected orderSubmitService = inject(OrderSubmitService);
  protected gungFlowService = inject(GungFlowService);

  creatingOrders: { [index: number]: boolean } = {};
  createdOrders: { [index: number]: string } = {};
  errorsInCreation: { [index: number]: string } = {};
  customerSpecificInfo: { [customerId: string]: { [productId: string]: CustomerSpecificProductInformation } };

  @Input()
  result: MultiOrderImportResult;

  ngOnChanges(): void {
    if (!this.result) {
      return;
    }

    this.gungFlowService
      .getSelectedFlow()
      .pipe(first())
      .subscribe(flow => {
        let customers = [];
        this.result.orders = this.result.orders.map(o => {
          if(o.billingCustomerId){
            customers.push(o.billingCustomerId);
          }
          o.extra._flow = flow;
          return o;
        });
        this.productService.getCustomersSpecificProductData(customers).pipe(first()).subscribe(res => {
          this.customerSpecificInfo = res;
        })
      });

  }

  createOrder(order: Order, index: number) {
    this.creatingOrders[index] = true;

    this.orderSubmitService
      .postOrder('json/order/create/GUNG_WEB', order)
      .pipe(first())
      .subscribe({
        next: res => {
          this.createdOrders[index] = res.erpOrderIds.join(', ');
          this.creatingOrders[index] = false;
        },
        error: err => {
          this.errorsInCreation[index] = err.message;
          this.creatingOrders[index] = false;
        }
      });
  }
}
